<template>
  <div>
    <div class="vx-row mx-2">
      <div class="router-header flex flex-wrap items-center mb-6">
        <div
          class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"
        >
          <h2 class="mb-1">แก้ไขข้อมูล </h2>
        </div>
        <!-- <p class="mx-5 mt-2">ผู้ใช้งานในโครงการ</p> -->
      </div>
    </div>
    <vx-card class="p-5">
      <div class="vx-row">
        <div class="vx-col md:w-1/6 w-full mt-5">
            <span class="text-sm">คำนำหน้า</span>
            <span class="text-danger text-sm">*</span>
            <div class="flex">
              <vs-select
                :class="[!toggleInput ? 'w-full' : 'w-1/2 mr-5']"
                v-model="editInfo.title"
                @change="checkToggleInput"
                v-validate="'required'"
                name="title"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in titleData"
                  class="w-full"
                />
              </vs-select>
              <vs-input
                v-if="toggleInput"
                label="ระบุ*"
                v-model="titleOther"
                class="w-1/2"
                v-validate="'required'"
                name="titleOter"
              />
            </div>
            <span
              class="text-danger text-sm"
              v-show="errors.has('title') || errors.has('titleOter')"
              >กรุณากรอก คำนำหน้า</span
            >
          </div>
          <div class="vx-col md:w-1/3 w-full mt-5">
            <span class="text-sm">ชื่อ</span>
            <span class="text-danger text-sm">*</span>
            <vs-input
              v-model="editInfo.firstName"
              class="w-full"
              v-validate="'required'"
              name="first_name"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('first_name')"
              >{{ errors.first("first_name") }}</span
            >
          </div>
          <div class="vx-col md:w-1/3 w-full mt-5">
            <span class="text-sm">นามสกุล</span>
            <span class="text-danger text-sm">*</span>
            <vs-input
              v-model="editInfo.lastName"
              class="w-full"
              v-validate="'required'"
              name="last_name"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('last_name')"
              >{{ errors.first("last_name") }}</span
            >
          </div>
          <div class="vx-col md:w-1/6 w-full mt-5">
            <span class="text-sm">ตำแหน่ง</span>
            <vs-input
              v-model="editInfo.position"
              class="w-auto"
            />
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <span class="text-sm">เบอร์โทร</span>
            <vs-input
              v-model="editInfo.phoneNumber"
              class="w-full"
              v-validate="'numeric'"
              name="phone_number"
            />
            <span class="text-danger text-sm" v-show="errors.has('phone_number')">{{
              errors.first("phone_number")
            }}</span>
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <span class="text-sm">อีเมล</span>
            <vs-input
              type="email"
              v-model="editInfo.email"
              class="w-auto"
              name="email"
            />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
            <span class="text-sm">ภาค</span>
            <span class="text-danger text-sm">*</span>
            <vs-select
              class="w-full select-large"
              v-model="editInfo.sector"
              v-validate="'required'"
              name="sector"
              disabled
            >
              <vs-select-item
                :key="index"
                :value="item.name"
                :text="item.name"
                v-for="(item, index) in sector"
                class="w-full"
              />
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('sector')"
              >กรุณาเลือก เขต</span
            >
          </div>
      </div>
      <div align="right" class="mt-10">
        <vs-button
          class="mr-5"
          color="primary"
          type="filled"
          @click="confirmEdit()"
          >ยืนยันการแก้ไข</vs-button
        >
        <vs-button color="danger" type="border" to="/users">ย้อนกลับ</vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { Validator } from "vee-validate";
import { DICT_VESSEL, DICT_USER } from "../../../../mock-data/form-validate.js";
// register custom messages
Validator.localize("en", DICT_VESSEL, DICT_USER);

export default {
  data() {
    return {
      editInfo: {},
      provinceName: [],
      districtName: [],
      subDistrictName: [],
      zipCode: null,
      selectDistrict: false,
      selectSubDistrict: false,
      inputZipCode: false,
      titleData: [
        { text: "นาย", value: "นาย" },
        { text: "นาง", value: "นาง" },
        { text: "นางสาว", value: "นางสาว" },
        { text: "อื่นๆ", value: "อื่นๆ" },
      ],
      toggleOther: true,
      toggleInput: false,
      sector: "",
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this.$store.dispatch("users/setUserById", {
        id: this.$route.params.id,
      });
      const userDetail = this.$store.state.users.user;
      this.editInfo = userDetail;
      console.log(this.editInfo);
    },
    confirmEdit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          Swal.fire({
            title: "ยืนยันการแก้ไขข้อมูล",
            text: "",
            icon: "question",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showCancelButton: true,
            preConfirm: () => {
              this.editInfo.title == "อื่นๆ"
                ? (this.editInfo.title = this.editInfo.other)
                : (this.editInfo.title = this.editInfo.title),
                console.log("this is editInfo ==> ", this.editInfo);

              this.$store.dispatch("users/setEditSuperVisor", this.editInfo);
            },
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire({
                icon: "success",
                title: "แก้ไขเรียบร้อยแล้ว",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.push("/users");
              });
            }
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "เกิดข้อผิดพลาด",
            text: "กรุณากรอกข้อมูลให้ถูกต้อง",
            showConfirmButton: false,
          });
        }
      });
    },
    onOther() {
      console.log("this is other", this.editInfo.title);
      if (this.editInfo.title == "อื่นๆ") {
        this.toggleOther = false;
      } else {
        this.toggleOther = true;
      }
    },
    checkToggleInput() {
      if (this.editInfo.title == "อื่นๆ") {
        this.toggleInput = !this.toggleInput;
      } else {
        this.toggleInput = false;
      }
      console.log("this is toggle :", this.editInfo.title);
    },
  },
};
</script>

<style lang="scss" scoped></style>
